import { render, staticRenderFns } from "./BootButton.vue?vue&type=template&id=e1a9f9d0&"
import script from "./BootButton.vue?vue&type=script&lang=js&"
export * from "./BootButton.vue?vue&type=script&lang=js&"
import style0 from "./BootButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports